//console.log("form",customElements.get('product-form'));
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        //this.form.querySelector('[name=id]').disabled = false;
        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        let wishlistData = this.submitButton.dataset.template;
        
        wishlistData == 'account' ? (this.closest('.grid__item').querySelector('.button-wishlist').click()) : console.log("defined");
        
        let popupId = this.submitButton.closest("form").querySelector('.product-variant-id').value;
        let popupMain_Title = this.submitButton.closest("form").querySelector('.product-variant-id').getAttribute("data-title");
        let productBtnId = this.submitButton.id;
        let crosssellStatus = this.submitButton.dataset.id;
        popupId = "popup_product_" + popupId;
        console.log("this", popupMain_Title);

        
       
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
      
        const formData = new FormData(this.form);
        
        const pricePerItemContainer = document.querySelector('.price-per-quantity__container');
         if (window.location.pathname.includes('/products/') || window.location.pathname.includes('/collections/')) {
           //const closestOffer = evt.target.closest('#ourOfferSlides');
           //console.log(closestElement, 'ths')
          if (pricePerItemContainer && pricePerItemContainer.getAttribute('data-quantityselector') === 'true' && !evt.submitter.className.includes('quick-add__submit product-form__submit button loading') && evt.target.closest('#ourOfferSlides') === null) {
              //console.log('checked', evt.submitter.className)
              //console.log('checked', evt)
            const selectedOption = document.querySelector('.multiple-quantity_selector input[name="option"]:checked');
            
            if (selectedOption) {
                formData.set('quantity', selectedOption.value);
            }
          }
        }


        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if(this.closest('.qty-atc-wrapper')){
          let qty = this.closest('.qty-atc-wrapper').querySelector('.quantity__input').value;
          if (pricePerItemContainer.getAttribute('data-quantityselector') === 'false'){
            formData.append('quantity',qty);
          }
              
        }
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            document.querySelector(".productNameModalid strong").innerHTML = popupMain_Title;
            crosssellStatus != undefined ? document.querySelector(".drawer").classList.add("opacity") : ( document.querySelector('.cross-cell-main') != null ? (document.querySelector('.cross-cell-main').classList.add('hidden'),document.querySelector(".drawer").classList.remove("opacity")) : console.log());
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            ajaxMethod(popupId,productBtnId);
         

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });


         // Update the cart when clicking "Add to Cart" in the "You May Also Like" section on the cart page.
         if (window.location.href.includes("cart")) {
             setTimeout(() => {
                 window.location.reload();
             }, 1000); 
         }


      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

function ajaxMethod(popupId){
   fetch('/?section_id=cart-drawer', {
    method: 'GET',
    headers: {
      'Content-Type': 'text/html'
    }
  })
  .then(response => response.text())
  .then(carthtml => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(carthtml, 'text/html');
    let html = doc.getElementById(popupId);
    
    console.log("html content",html,popupId);
    if (html) {
      html = html.innerHTML;
      document.querySelector('.upsell__product').innerHTML = html;
      document.querySelector('.cross-cell-main').classList.remove('hidden');
      document.querySelector('body').classList.add('cross-cell-open');
      swipersCode();
    }
  })
  .catch(error => {
    console.error('Error:', error);
  });
}
if(document.querySelector('.cross-cell-main-overlay')){
 document.querySelector('.cross-cell-main-overlay').addEventListener("click", function () {
     close_crosscell_popup();
   });
 document.querySelector('.close-cross-cell-popup').addEventListener("click", function () {
     close_crosscell_popup();
   });
}
 function close_crosscell_popup(){
   document.querySelector(".cross-cell-main").classList.add("hidden");
   document.querySelector('body').classList.remove('cross-cell-open');
   document.querySelector(".drawer").classList.remove("opacity");
   document.querySelector("body").classList.remove("overflow-hidden");
 }


document.addEventListener('click', function(event) {
  const popup = document.querySelector(".cross-cell-main"); 
  const popup_main = document.querySelector(".cross-cell-inner");  
  //const quickView = document.querySelector("input.input-quantity");
  //const quickAddContentInfo = document.querySelector("quick-add-modal.quick-add-modal .quick-add-modal__content");
  const quickAddContentInfos = document.querySelectorAll(".quick-add-modal .quick-add-modal__content");
  
  let insideModal = false;
  quickAddContentInfos.forEach(quickAddContentInfo => {
    // If the click target is inside any .quick-add-modal__content, set flag to true
    if (quickAddContentInfo.contains(event.target)) {
      insideModal = true;
    }
  });

  // If click is inside any modal content, return early
  if (insideModal) {
    return;
  }
  if (popup && popup_main && !popup_main.contains(event.target)) {
    //console.log(event.target)
    close_crosscell_popup();
  }


});


function swipersCode() {
  var swiperss = new Swiper(".swiper-cross-cell-products", {
    slidesPerView: 4,
    spaceBetween: 20,
    draggable: false,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      750: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });
}
                                                    
                                                              
                                                      












